module.exports = __webpack_public_path__ + "img/ÜbungsdiensteFeb23(2).19a87721.jpg";